import { useCallback /*, useState, useEffect*/ } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
	EmbeddedCheckoutProvider,
	EmbeddedCheckout,
} from "@stripe/react-stripe-js";
/*import {
	BroswerRouter as Router,
	Route,
	Routes,
	Navigate,
} from "react-router-dom";*/
import { useHttpClient } from "../../shared/hooks/http-hook";

const stripeKey = process.env.REACT_APP_STRIPE_KEY;
const stripeTestKey = process.env.REACT_APP_STRIPE_TEST_KEY;

const CheckoutForm = ({ ticketId }) => {
	const { sendRequest } = useHttpClient();
	// if enviromnet is development, use test key
	let stripePromise;
	if (process.env.NODE_ENV === "development") {
		stripePromise = loadStripe(
			stripeTestKey
		);
	} else {
		stripePromise = loadStripe(
			stripeKey
		);
	}

	const fetchClientSecret = useCallback(async () => {
		const response = await sendRequest(
			`/api/create-checkout-session/${ticketId}`,
			"POST"
		);

		if (response?.data?.clientSecret) {
			return response.data.clientSecret;
		} else {
			throw new Error("Failed to get client secret");
		}
	}, [ticketId, sendRequest]);

	return (
		<div id="checkout">
			<EmbeddedCheckoutProvider
				stripe={stripePromise}
				options={{ fetchClientSecret }}
			>
				<EmbeddedCheckout />
			</EmbeddedCheckoutProvider>
		</div>
	);
};

/*const Return = () => {
	const [status, setStatus] = useState(null);
	const [customerEmail, setCustomerEmail] = useState("");

	useEffect(() => {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const sessionId = urlParams.get("session_id");

		fetch(`/session-status?session_id=${sessionId}`)
			.then((res) => res.json())
			.then((data) => {
				setStatus(data.status);
				setCustomerEmail(data.customer_email);
			});
	}, []);

	if (status === "open") {
		return <Navigate to="/checkout" />;
	}

	if (status === "complete") {
		return (
			<section id="success">
				<p>
					We appreciate your business! A confirmation email will be sent to{" "}
					{customerEmail}. If you have any questions, please email{" "}
					<a href="mailto:orders@example.com">orders@example.com</a>.
				</p>
			</section>
		);
	}

	return null;
};*/

export default CheckoutForm;
